const REPORT_KEYS = ['report-a', 'report-b', 'report-c', 'report-d', 'report-e', 'report-f', 'report-g'];
const QUESTION_KEYS = ['question-a', 'question-b', 'question-c', 'question-d', 'question-e', 'question-f'];
const CHECKBOX_GRID_KEYS = ['analysis-a', 'analysis-b', 'analysis-c', 'analysis-d'];
const TREE_ITEM_KEYS = ['fact-a', 'fact-b', 'fact-c'];
const INTRO_KEYS = ['intro-a', 'intro-b', 'intro-c'];

const CheckboxPlaceholder = () => (
  <span
    className="placeholder rounded-1 flex-shrink-0"
    style={{ width: 16, height: 16 }}
  />
);

const ExpandIconPlaceholder = () => (
  <span
    className="placeholder rounded-1 flex-shrink-0"
    style={{ width: 14, height: 14 }}
  />
);

const TogglePlaceholder = () => (
  <span
    className="placeholder rounded-pill flex-shrink-0"
    style={{ width: 36, height: 18 }}
  />
);

const ActionButtonsPlaceholder = () => (
  <div className="d-inline-flex align-items-center gap-2">
    <span className="placeholder rounded" style={{ width: 150, height: 36 }} />
    <span className="placeholder rounded" style={{ width: 110, height: 36 }} />
  </div>
);

const SectionHeaderPlaceholder = ({ titleWidth }: { titleWidth: number }) => (
  <div className="row align-items-center">
    <div className="col">
      <span
        className="placeholder"
        style={{ width: titleWidth, height: '1.1rem' }}
      />
    </div>
    <div className="col text-end">
      <div className="d-inline-flex align-items-center gap-2">
        <TogglePlaceholder />
        <span className="placeholder" style={{ width: 70, height: '0.85rem' }} />
      </div>
    </div>
  </div>
);

const TreeListPlaceholder = ({ keys }: { keys: Array<string> }) => (
  <>
    {keys.map((key) => (
      <div className="d-flex align-items-center gap-2 my-2" key={key}>
        <ExpandIconPlaceholder />
        <CheckboxPlaceholder />
        <span className="placeholder col-8" />
      </div>
    ))}
  </>
);

const CheckboxGridPlaceholder = ({ keys }: { keys: Array<string> }) => (
  <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4">
    {keys.map((key) => (
      <div className="col JurisdictionCss mb-2" key={key}>
        <div className="d-flex align-items-center gap-2">
          <CheckboxPlaceholder />
          <span className="placeholder col-9" />
        </div>
      </div>
    ))}
  </div>
);

interface SkeltonProps {
  /** When true, includes breadcrumb + top action buttons (full-page load). */
  includePageHeader?: boolean;
  /** When true, mirrors Opinion Compare Tab side-by-side Reports | Questions layout. */
  showTabGrid?: boolean;
}

const Skelton = ({
  includePageHeader = false,
  showTabGrid = false,
}: SkeltonProps) => {
  const selectionSections = showTabGrid ? (
    <div className="row">
      <div className="col-12 col-md-6 bor-R">
        <SectionHeaderPlaceholder titleWidth={120} />
        <hr className="my-2" />
        <TreeListPlaceholder keys={REPORT_KEYS} />
      </div>
      <div className="col-12 col-md-6">
        <SectionHeaderPlaceholder titleWidth={140} />
        <hr className="my-2" />
        <TreeListPlaceholder keys={QUESTION_KEYS} />
      </div>
    </div>
  ) : (
    <>
      <SectionHeaderPlaceholder titleWidth={120} />
      <hr className="my-2" />
      <CheckboxGridPlaceholder keys={CHECKBOX_GRID_KEYS} />

      <div className="col-12 mt-3">
        <SectionHeaderPlaceholder titleWidth={170} />
      </div>
      <hr className="my-2" />
      <TreeListPlaceholder keys={TREE_ITEM_KEYS} />
    </>
  );

  const body = (
    <div className="placeholder-glow">
      <div className="ao_rowBg ao_showSourceCont ao_whiteBg mb-3">
        {INTRO_KEYS.map((key) => (
          <div className="mb-2" key={key}>
            <span className="placeholder col-11" />
          </div>
        ))}
        <span className="placeholder col-7" />
      </div>

      <div className="col-12">
        {selectionSections}

        <div className="d-flex justify-content-between align-items-center mt-3">
          <span
            className="placeholder rounded"
            style={{ width: 220, height: 36 }}
          />
          <ActionButtonsPlaceholder />
        </div>
      </div>
    </div>
  );

  if (!includePageHeader) {
    return body;
  }

  return (
    <div className="v3-compare-theme-scope placeholder-glow">
      <div className="container-fluid ao_rowBg boxShadowOutset py-3">
        <div className="ao_mainContainer">
          <div className="d-sm-flex align-items-center">
            <span className="placeholder col-4" style={{ height: '1.5rem' }} />
            <div className="ms-auto text-end">
              <ActionButtonsPlaceholder />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="ao_mainContainer py-3">
          <div className="tab-content">
            <div className="tab-pane fade show active ao_whiteBg">{body}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skelton;
